export * from './auto-focus.directive';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/directives/index.ts